import { __spreadArrays } from "tslib";
export { renderAndMountComponent } from '@wix/answers-lib';
export { findInPopover } from './find-in-popover';
export { ClickOutside } from './click-outside.comp';
export { isUrl } from './is-url';
export * from './domain';
export * from './namespace-classes';
export * from './user-input-commons';
export * from './key-codes.enum';
export * from './render-html';
export * from './base-driver';
export * from './resize-observer';
export * from './hooks';
export * from './react-select';
export var noop = function () { return undefined; };
export var delay = function (time) { return new Promise(function (res) { return setTimeout(res, time); }); };
export var isPromise = function (maybeP) {
    return maybeP && maybeP.then && maybeP.catch;
};
export var flattenCategories = function (cats) {
    return cats.reduce(function (p, c) {
        var children = c.children || [];
        var childrenFlats = children.reduce(function (sp, sc) {
            return __spreadArrays([{ id: sc.id, name: sc.name, parentName: c.name }], sp);
        }, []);
        return __spreadArrays(p, [{ id: c.id, name: c.name }], childrenFlats);
    }, []);
};
export var isTestEnvironment = function () { return process.env.IS_TEST === 'true'; };
export var setTestEnvironment = function () { return process.env.IS_TEST = 'true'; };
//# sourceMappingURL=index.js.map